import { get } from './http'

/** 课程详情（公开接口，无需登录） */
export function fetchCourseInfo(id) {
  return get('/course/info', { id })
}

/** 老师详情（公开接口，无需登录） */
export function fetchTeacherInfo(id) {
  return get('/teacher/info', { id })
}
